export default class DocumentStatusPollingTimeoutError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DocumentStatusPollingTimeoutError';
  }
}
